export const restaurant = {
  restaurant_name: "",
  phone: "",
  email: "",
  locality: "",
  city: "",
  state: "",
  country: "",
  about: "",
  postal_code: "",
  owner_name: "",
  cuisine_type: "",
  commission: "",
  status: "",
  category: "",
  meal_type: "",
  meals: [],
  price_plans: [],
  documents: [{ restaurant_image: "" }, { banner_image: "" }],
  papers: [],
  account_name: "",
  account_number: "",
  bank_name: "",
  branch_number: "",
  institution_number: "",
  profit_margins: []
};
export const meal = {
  meal_name: "",
  slot: "",
  type: "",
  day: "",
  image: "",
  add_on: [
    {
      add_on: "",
      price: "",
      add_on_image: "",
    },
  ],
};
export const requests = [];
export const profit_margins = []
